import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { AssignType } from '../../pages/admin/icontact/search/search.const';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

@Injectable()
export class SearchService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  user(query?: any) {
    return this.get('/search/user', query);
  }
  fetch(query?: any) {
    return this.get('/v2/tickets', query);
  }
  list(params?: any, body?: any) {
    const search = new URLSearchParams(params);
    const query = `?${search}`;
    return this.post('/v2/ticket/search' + query, body);
  }

  all(body?: any, params?: any, type?: any) {
    // console.log('search ticket = {}', params);
    let url = '';
    let method = 'POST';
    // console.log('TYPE:', type);
    switch (type) {
      case AssignType.MissedCall:
      case AssignType.NotTag:
      case AssignType.Campaign:
      case AssignType.Open:
      case AssignType.InProcess:
      case AssignType.Completed:
      case AssignType.NearExpired:
        url = '/v2/tickets';
        method = 'GET';
        break;
      default:
        url = '/v2/ticket/search';
        if (body.type == 'organize') {
          url = '/search';
        } else if (body.type == 'user') {
          url = '/v2/contacts/search';
        }
        break;
    }
    if (params) {
      const search = new URLSearchParams(params);
      url += `?${search}`;
      // console.log('URL:', url);
    }
    if (method === 'GET') {
      return this.get(url);
    } else {
      return this.post(url, body);
    }
  }
  createFilter(body) {
    return this.post('/v2/filter', body);
  }

  deleteFilter(filter_id) {
    return this.delete('/v2/filter/' + filter_id);
  }

  updateFilter(filter_id, body) {
    return this.put('/v2/filter/' + filter_id, body);
  }
  listFilter(query = {}) {
    return this.get('/v2/filters', query);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Search.service.ts